<template>
    <div
        class="outlet-banner"
        :style="{
            'background-image': `linear-gradient(to bottom, rgba(0,0,0,0), rgba(0,0,0, 0.40)), url('/images/terms and condition/policyfdDH.jpg')`,
        }"
    ></div>
    <div class="privacy-policies-page-container">
        <div class="Privacy-policies headline-section">Privacy Policies</div>
        <div class="privacy-policies-para">
            At <a href="https://penpencilbd.com" target="_blank">penpencilbd.com</a>, 
            we are committed to protecting your privacy while providing you with 
            high-quality stationery products and a smooth shopping experience. 
            We value the trust you place in us, and we ensure that your personal 
            data is handled with transparency and care. This policy explains how 
            we collect, use, and safeguard your information when you interact with 
            our website and services.
        </div>

        <div class="personal-privacy headline-section">
            Maintaining Personal Privacy:
        </div>
        <div class="personal-privacy-details">
            <ol>
                <li>We clearly explain why we ask for your personal details.</li>
                <li>
                    We are transparent about how your data will be used
                    (e.g., order processing, delivery updates, or offers).
                </li>
                <li>
                    We only keep your information for as long as it is needed
                    for business or legal purposes.
                </li>
                <li>
                    We limit access to your information strictly to our support
                    and service teams.
                </li>
            </ol>
        </div>

        <div class="needded-info headline-section">
            Information We Collect:
        </div>
        <div class="needed-following-details-section">
            <ol>
                <li>
                    Order Information: Your name, address, email, and phone
                    number are required to process and deliver your stationery
                    orders.
                </li>
                <li>
                    Usage Data: We may collect anonymous information about how
                    you browse our website to improve your shopping experience.
                </li>
                <li>
                    Optional Information: If you sign up for newsletters or
                    promotions, we will collect your email address for
                    communication.
                </li>
            </ol>
        </div>

        <div class="id-email headline-section">Id and Email Information</div>
        <div class="id-email-details-section">
            <ol>
                <li>
                    We do not sell, trade, or share your personal information
                    with third parties, advertisers, or banks. Your details are
                    used solely for completing your stationery purchases and
                    customer support.
                </li>
                <li>
                    In rare cases, we may disclose your information if required
                    by law, regulatory authorities, or to protect our business
                    and customers.
                    <br />
                    Security of Data: We follow strict practices to keep your
                    data secure:
                    <ol type="A">
                        <li>Encryption of Data</li>
                        <li>Secure Servers</li>
                        <li>Firewalls</li>
                        <li>Password Protection</li>
                        <li>
                            Limited Retention: We only keep your order history
                            and contact information for as long as necessary.
                            Payment information is not stored by us.
                        </li>
                    </ol>
                </li>
            </ol>
        </div>

        <div class="rights-to-policy headline-section">Your Privacy Rights</div>
        <div class="rights-to-policy-heading-details">
            <ol>
                <li>
                    Right of Access: You can request access to the personal
                    information you’ve shared with us.
                </li>
                <li>
                    Right to Correct: You may contact us to correct any
                    inaccuracies in your stored information.
                </li>
                <li>
                    Right to Withdraw: You may request deletion of your personal
                    data at any time by contacting us through official channels.
                </li>
                <li>
                    Contact Us: If you have any questions or concerns about this
                    privacy policy, please email us at
                    <a href="mailto:info.penpencilbd@gmail.com">info.penpencilbd@gmail.com</a>.
                </li>
            </ol>
        </div>
    </div>
</template>



<style lang="scss" scoped>
.privacy-policies-page-container {
    // padding: 50px 10%;
}

.drop-down-language-container {
    border: 2px solid #e6e6e6;
    border-radius: 10px;
    font-size: 18px;
    padding: 17px 21px;
    width: 20%;
    margin-bottom: 50px;
}

.headline-section {
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 20px;
}

.text-section {
    font-size: medium;
    font-weight: 400;
}

.heading-and-image-section {
    align-items: center;
}
.heading-section {
    font-size: 50px;
}

.bg-image-section {
    background-image: url("../../assets/images/1.png");
    background-repeat: no-repeat;
    background-size: contain;
    border-radius: 20px;
    height: 320px;
    background-position: center;
}

@media screen and (min-width: 0px) and (max-width: 576px) {
    .heading-section {
        font-size: 35px;
    }
}
</style>
